//Calculate if need to reverse orders of bands
//based on dispatch type and bid type

import { BidType, UnitDispatchType } from "../enums";

export const CalcIfReverseBands = (bidType, dispatchType) =>
  bidType === BidType.Energy && dispatchType === UnitDispatchType.Load;
